
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import CrossIconNew from "@/components/icons/CrossIconNew.vue";
import TableView from "@/components/v2/table/NewTable.vue";
import FileFilled from "@/components/icons/FileFilled.vue";
import moment from "moment";
import FormError from "@/components/common/FormError.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import UIButton from "@/components/button/ui-button.vue";
@Component({
  components: {
    ModalFullScreen,
    CrossIconNew,
    TableView,
    FileFilled,
    FormGroup,
    UIButton,
    FormError,
    FormTextarea,
  },
})
export default class InvoiceDashboard extends Vue {
  @Prop({ type: String, required: true }) readonly name!: string;
  @Prop({ type: Boolean, required: true }) readonly showAlert!: boolean;

  selectedReason = null;
  note = null;
  get loading() {
    return this.$apollo.loading;
  }
  onSubmit(value) {
    this.$emit("submit", { reason: this.selectedReason, note: this.note });
  }
}
